/** Maps each targetFieldId to the indices of every rule targeting it. */
export function buildRuleDependencyGraph(rules) {
    const rulesByTarget = new Map();
    rules.forEach((rule, index) => {
        const existing = rulesByTarget.get(rule.targetFieldId);
        if (existing)
            existing.push(index);
        else
            rulesByTarget.set(rule.targetFieldId, [index]);
    });
    return rulesByTarget;
}
//# sourceMappingURL=rule-dependency-graph.js.map